import { render, staticRenderFns } from "./DevappAttachments.vue?vue&type=template&id=5809759e"
import script from "./DevappAttachments.vue?vue&type=script&lang=js"
export * from "./DevappAttachments.vue?vue&type=script&lang=js"
import style0 from "./DevappAttachments.vue?vue&type=style&index=0&id=5809759e&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports